import { render, staticRenderFns } from "./ExcTickerLogo.vue?vue&type=template&id=75981c10&scoped=true&"
import script from "./ExcTickerLogo.vue?vue&type=script&lang=js&"
export * from "./ExcTickerLogo.vue?vue&type=script&lang=js&"
import style0 from "./ExcTickerLogo.vue?vue&type=style&index=0&id=75981c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75981c10",
  null
  
)

export default component.exports